import { schema } from 'normalizr'

const serviceSchema = new schema.Entity('services')

const coursesSchema = new schema.Entity('courses', {
  service: serviceSchema,
})

const coursesArray = [coursesSchema]

export default coursesArray



// WEBPACK FOOTER //
// ./src/schemas/boughtCourses.js